import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { AppConstants } from 'src/app/shared/app.constants';

@Component({
  selector: 'ness-approval-comment',
  templateUrl: './approval-comment.component.html'
})
export class ApprovalCommentComponent implements OnDestroy {
  approvalForm: FormGroup = this.fb.group({
      Comments: ['', Validators.required]
    });
  @Output() approvalSubmitted: EventEmitter<string> = new EventEmitter();
  @Output() closeForm: EventEmitter<any> = new EventEmitter();
  @Input() data: ServerModels.ENESS_ApplicationUser = null;
  textAreaRows: number = AppConstants.defaultTextAreaRows;

  private _unsubscribe$: Subject<void> = new Subject<void>();
  
  constructor(private fb: FormBuilder) { }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  public clearData(): void {
    this.approvalForm.reset({
      Comments: ''
    });
  }

  public onCancel(): void {
    this.closeForm.emit(true);
    this.clearData();
  }

  public onSubmit(): void {
    if (this.data) {
      let data = JSON.stringify({
        'username': this.data.UserName,
        'status':  this.data.ENESS_REF_ApprovalHistory.Status,
        'comment': this.approvalForm.get('Comments').value
      });
      this.approvalSubmitted.emit(data);
      this.clearData();
    }
  }
}
